var _circle, _path, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDesktop = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 26,
  height: 26,
  fill: "none",
  viewBox: "0 0 26 26"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 13,
  r: 12,
  stroke: "currentColor",
  strokeWidth: 1.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M21.331 17.713a9.6 9.6 0 0 1-8.365 4.887A9.6 9.6 0 0 1 4.6 17.713c1.647-2.097 4.776-3.513 8.366-3.513s6.718 1.416 8.365 3.513",
  clipRule: "evenodd"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 8.5,
  r: 3.75,
  fill: "currentColor"
})));
export default SvgDesktop;